import { render, staticRenderFns } from "./Wap_PZD001_Step2.vue?vue&type=template&id=8a082a32&scoped=true&"
import script from "./Wap_PZD001_Step2.vue?vue&type=script&lang=js&"
export * from "./Wap_PZD001_Step2.vue?vue&type=script&lang=js&"
import style0 from "./Wap_PZD001_Step2.vue?vue&type=style&index=0&id=8a082a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a082a32",
  null
  
)

export default component.exports